import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home.vue'
import Select from '../components/Select.vue'
import Wind from '../components/Wind.vue'
import Principles from '../components/Principles.vue'
import About from '../components/About.vue'
import Contact from '../components/Contact.vue'
import Resources from '../components/Resources.vue'
import Approvals from '../components/Approvals.vue'
import Start from '../components/Started.vue'
import House from '../components/House.vue'
import House1 from '../components/House1.vue'
import House2 from '../components/House2.vue'
import House2a from '../components/House2a.vue'
import House3a from '../components/House3a.vue'
import House3 from '../components/House3.vue'
import House3tile from '../components/House3tile.vue'
import House4 from '../components/House4.vue'
import House4tile from '../components/House4tile.vue'
import Details from '../components/Details.vue'
import Levels from '../components/Levels.vue'
import Disclaimer from '../components/Disclaimer.vue'
import Maintenance from '../components/Maintenance.vue'
import Window from '../components/Window.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home

  },
    {
        path: '/wind',
        name: 'Wind',
        component: Wind
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },
    {
        path: '/principles',
        name: 'Principles',
        component: Principles
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },
    {
        path: '/approvals',
        name: 'Approvals',
        component: Approvals
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },
    {
        path: '/levels',
        name: 'Levels',
        component: Levels
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },
  {
    path: '/select',
    name: 'Select',
    component: Select,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    children: [
        {
            path: '/',
            name: 'Start',
            component: Start,
        },

        {
            path: 'house',
            name: 'House',
            component: House,
            props(route: any) {
                return  route.query || {}
            }
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
        }
        ,
        {
            path: 'house1',
            name: 'House1',
            component: House1,
            props(route: any) {
                return  route.query || {}
            }
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
        }
        ,
        {
            path: 'house2',
            name: 'House2',
            component: House2,
            props(route: any) {
                return  route.query || {}
            }
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
        }
        ,
        {
            path: 'house2a',
            name: 'House2a',
            component: House2a,
            props(route: any) {
                return  route.query || {}
            }
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
        }
        ,
        {
            path: 'house3a',
            name: 'House3a',
            component: House3a,
            props(route: any) {
                return  route.query || {}
            }
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
        }

        ,
        {
            path: 'house3',
            name: 'House3',
            component: House3,
            props(route: any) {
                return  route.query || {}
            }
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
        }

        ,
        {
            path: 'house3tile',
            name: 'House3tile',
            component: House3tile,
            props(route: any) {
                return  route.query || {}
            }
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
        }

        ,
        {
            path: 'house4',
            name: 'House4',
            component: House4,
            props(route: any) {
                return  route.query || {}
            }
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
        }
        ,
        {
            path: 'house4tile',
            name: 'House4tile',
            component: House4tile,
            props(route: any) {
                return  route.query || {}
            }
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
        }
        ,
        {
            path: 'details',
            name: 'Details',
            component: Details
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
        }

    ]

  },
  {
      path: '/about',
      name: 'About',
      component: About
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
  },
  {
        path: '/disclaimer',
        name: 'Disclaimer',
        component: Disclaimer
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
  },
  {
      path: '/contact',
      name: 'Contact',
      component: Contact
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
  },
    {
        path: '/resources',
        name: 'Resources',
        component: Resources
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },
    {
        path: '/maintenance',
        name: 'Maintenance',
        component: Maintenance
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },
    {
        path: '/window',
        name: 'Window',
        component: Window
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },

    { path: "*", component: Home }
]

const router = new VueRouter({
  scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
          return savedPosition
      } else {
          return { x: 0, y: 0 }
      }
  },
  base: process.env.BASE_URL,
  routes
})

export default router
